/**
 * 첨부 파일 URL 로부터 표시 유형을 판별한다.
 *  - video    : 동영상 확장자
 *  - document : 문서/오피스/압축 등(공지 첨부에서 사진 외 파일)
 *  - image    : 그 외(기존 동작 유지 — 확장자 미상은 이미지로 간주)
 */
export type AttachmentMediaType = "image" | "video" | "document";

const VIDEO_EXTENSIONS = [
  ".mp4",
  ".mov",
  ".avi",
  ".webm",
  ".mkv",
  ".m4v",
  ".3gp",
];

const DOCUMENT_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".hwp",
  ".hwpx",
  ".txt",
  ".csv",
  ".zip",
];

export const getAttachmentMediaType = (url: string): AttachmentMediaType => {
  const lowerUrl = (url || "").toLowerCase().split("?")[0];
  if (VIDEO_EXTENSIONS.some((ext) => lowerUrl.endsWith(ext))) return "video";
  if (DOCUMENT_EXTENSIONS.some((ext) => lowerUrl.endsWith(ext)))
    return "document";
  return "image";
};

/** URL(및 쿼리스트링) 에서 파일명만 추출. 실패 시 "첨부파일" */
export const getFileNameFromUrl = (url: string): string => {
  try {
    const noQuery = (url || "").split("?")[0];
    const last = decodeURIComponent(noQuery.split("/").pop() || "");
    return last || "첨부파일";
  } catch {
    return "첨부파일";
  }
};
